export const getUserInitial = (...values) => {
  const displayValue = values.find((value) => String(value ?? '').trim());
  return String(displayValue ?? 'A')
    .trim()
    .charAt(0)
    .toUpperCase();
};
